require('./brokerPensionPlanContributionView.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
import { v1 as uuidv1 } from 'uuid';
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ModalUsPersonBlock } = require('components/commons/modalUsPersonBlock/modalUsPersonBlock');
// @ actions
const brokerPensionPlanContributionActions = require('actions/brokerPensionPlanContribution');
const brokerPensionPlansActions = require('actions/brokerPensionPlans');
const profileActions = require('actions/profile');
const preContractualMailInfoActions = require('actions/preContractualMailInfo');
const brokerProductAdvancedSearchActions = require('actions/brokerProductAdvancedSearch');
import { getInitPlansDocumentation } from 'actions/brokerLegalDocumentation';
// @ components
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const BrokerPensionPlanExtraordinaryStep1 = require('components/broker/brokerPensionPlanContribution/pensionPlanExtraordinary/pensionPlanExtraordinaryStep1/pensionPlanExtraordinaryStep1');
const BrokerPensionPlanExtraordinaryStep2 = require('components/broker/brokerPensionPlanContribution/pensionPlanExtraordinary/pensionPlanExtraordinaryStep2/pensionPlanExtraordinaryStep2');
const BrokerPensionPlanExtraordinarySuccess = require('components/broker/brokerPensionPlanContribution/pensionPlanExtraordinary/pensionPlanExtraordinarySuccess/pensionPlanExtraordinarySuccess');
const BrokerPensionPlanHeader = require('components/broker/brokerPensionPlanHeader/brokerPensionPlanHeader');
// @ utilities
const { taggingEventHandled } = require('utilities/taggingEventHandled');
// @Contact Center constants
const {
    PENSION_PLAN_STANDARD,
    PENSION_PLAN_CONTRIBUTION_PRODUCT_TYPE,
    PENSION_PLAN_PRODUCT_SUB_TYPE,
} = require('constants/contactCenter/pensionPlans');

// @Contact Center
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');
const NextButtonWrapper = require("components/contactCenter/nextButtonWrapper/nextButtonWrapper");
const { PensionPlanLegalConfirmation } = require('components/contactCenter/brokerLegalConfirmation/pensionPlanLegalConfirmation/pensionPlanLegalConfirmation');

// @constants
const {
    BROKER_PLANS_HELP_URL,
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_PLANS_URL,
    BROKER_PG_URL
} = require('constants/index');

const { BROKER_EXTRAORDINARY_PENSION_PLAN } = require('utilities/tagging');

class BrokerPensionPlanContributionView extends React.Component {
    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.findWalletPlan = this.findWalletPlan.bind(this);
        this.handleShowWizard = this.handleShowWizard.bind(this);
        this.handleLegalYesNoOptionChange = this.handleLegalYesNoOptionChange.bind(this);

        this.state = {
            displayWizard: !__CONTACT_CENTER__,
            selectedLegalConfirmationValue: SELECTED_VALUES.EMPTY
        };
    }

    componentWillMount() {
        const { planId } = this.props.match.params;
        this.props.getPensionPlans(planId);
        const walletPlan = this.findWalletPlan();
        this.props.setContract(walletPlan, this.props.history);
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.clearSearchResults();
    }

    componentDidUpdate(prevProps) {
        const { immSignaturePattern } = this.props;
        if (
          !prevProps.immSignaturePattern.get('isFetchingConfig') &&
          immSignaturePattern.get('isFetchingConfig') &&
          immSignaturePattern.get('isFetchingConfigSuccess')
        ) {
          taggingEventHandled(BROKER_EXTRAORDINARY_PENSION_PLAN, 'otpInit');
        }
    }

    buildSuccessful() {
        const { immPensionPlanContribution, immStocksContracts } = this.props;

        return (
            <div className="row no-gutter">
                <div className="col-lg-12">
                    <BrokerPensionPlanExtraordinarySuccess
                        immPensionPlanContribution={immPensionPlanContribution}
                        immStocksContracts={immStocksContracts}
                    />
                </div>
            </div>
        );
    }

    handleShowWizard (){
        this.setState({
            displayWizard: true,
        })
    }

    handleLegalYesNoOptionChange(value) {
        this.setState({
            selectedLegalConfirmationValue: value
        });
    }

    buildWizard() {
        const {
            immPensionPlan,
            immPensionPlanContribution,
            immAccounts,
            validateStep,
            setVisibleStep,
            setWillCancel,
            setOriginalAmount,
            setPeriodicity,
            onToggleDisclaimer,
            setDocumentsRead
        } = this.props;

        const { displayWizard } = this.state;

        const immSteps = immPensionPlanContribution.get('steps');
        const stepLoading = immPensionPlanContribution.get('isFetching');
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.props.handleFinish,
            cancel: this.handleCancel
        };

        const headerMenuData = {
            title: formatText('pensionPlanContribution-headerExtraordinaryTitle'),
            linksData: ['']
        };

        const pasoProceso = immPensionPlanContribution.get('visibleStep') && immPensionPlanContribution.get('visibleStep') !== 1
        ? `paso_${immPensionPlanContribution.get('visibleStep')-1}`
        : 'inicio';

        const tealium = immPensionPlanContribution.get('visibleStep')
        ? {
            pasoProceso: pasoProceso,
        } : null;

        return (
            displayWizard && <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immPensionPlanContribution.get('visibleStep')}
                hasHeaderMenu={true}
                headerMenuData={headerMenuData}
                tealium={tealium}
                isTaggingSecondVersion
            >
                <WizardStep position="first" cancelButton={true}>
                    <BrokerPensionPlanExtraordinaryStep1
                        immPensionPlanContribution={immPensionPlanContribution}
                        immBrokerPensionPlans={immPensionPlan}
                        immAccounts={immAccounts}
                        setOriginalAmount={setOriginalAmount}
                        setPeriodicity={setPeriodicity}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    immFinalButton="pensionPlanContribution-finalButton"
                    addLoadingBehaviour={true}
                    isLoading={stepLoading}
                >
                    <BrokerPensionPlanExtraordinaryStep2
                        immPensionPlanContribution={immPensionPlanContribution}
                        onToggleDisclaimer={onToggleDisclaimer}
                        setDocumentsRead={setDocumentsRead}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    findWalletPlan() {
        const { immBrokerWallets, immPensionPlanContribution } = this.props;
        const { planId } = this.props.match.params;

        const contractNumber = immPensionPlanContribution.get('contractNumber');
        const planIdDivided = planId.split('-');

        return immBrokerWallets.get('plansList').find((immPlan) => {
            const planProduct = immPlan.getIn(['contrato', 'producto']);
            const planSubProduct = immPlan.getIn(['criterios', 'c1', 'subtipoproducto']);
            const productAndSubProductMatch = (planProduct === planIdDivided[0] && planSubProduct === planIdDivided[1]);

            if (contractNumber) {
                return productAndSubProductMatch && immPlan.getIn(['contrato', 'numerodecontrato']) === contractNumber
            }

            return productAndSubProductMatch;
        });
    }

    handleCancel() {
        this.props.history.push(`/myprofile/broker`);
    }

    buildNextButtonWrappedLegalConfirmation() {
        const {
            immPensionPlan,
            immProfileFields,
            getInitPlansDocumentation,
            requestProfile,
            resetPrecontractualMail,
            sendPreContractualMail,
            immPreContractualMail,
        } = this.props;

        const {
            selectedLegalConfirmationValue,
        } = this.state;
        const { name, dgscode, secId } = immPensionPlan.get('pensionPlan').toJS();

        if (__CONTACT_CENTER__) getInitPlansDocumentation(uuidv1(), dgscode, false)

        const sendMailParams = {
            productName: name,
            standar: PENSION_PLAN_STANDARD,
            type: PENSION_PLAN_CONTRIBUTION_PRODUCT_TYPE,
            subType: PENSION_PLAN_PRODUCT_SUB_TYPE
        };

        const pensionPlanLegalDesclaimer = "pensionPlanLegalConfirmation-legalDisclaimerQuestionFirstStatementExtraordinaryContrib";
        const pensionPlanLegalFirstQuestion = "pensionPlanLegalConfirmation-legalDisclaimerDocumentsLinksContributionsFirstStatement";

        const isAbleToContinueToWizard = immPreContractualMail.get('mailSent') && selectedLegalConfirmationValue === SELECTED_VALUES.YES && !immProfileFields.get('error');

        return(
            <article className="content-box broker-hire-pension-plan__legal-confirmation" id="printable-wizard">
                <NextButtonWrapper
                    canContinue={isAbleToContinueToWizard}
                    onContinue={this.handleShowWizard}
                >
                    <PensionPlanLegalConfirmation
                        planDgsCode={dgscode}
                        planSecId={secId}
                        pensionPlanFullName={name}
                        requestProfile={requestProfile}
                        immProfileFields={immProfileFields}
                        onYesNoOptionChange={this.handleLegalYesNoOptionChange}
                        selectedYesNoOption={this.state.selectedLegalConfirmationValue}
                        sendMail={sendPreContractualMail}
                        resetMailState={resetPrecontractualMail}
                        immPreContractualMail={immPreContractualMail}
                        sendMailParams={sendMailParams}
                        pensionPlanLegalDesclaimer={pensionPlanLegalDesclaimer}
                        pensionPlanLegalFirstQuestion={pensionPlanLegalFirstQuestion}
                    />
                </NextButtonWrapper>
            </article>
        );
    }

    render() {
        const {
            immBrokerProductAdvancedSearch,
            immPensionPlanContribution,
            immPensionPlan,
            immHirePensionPlan,
            flagBasedFeatures,
            history
        } = this.props;
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('plans-plans'),
                url: MYPROFILE_BROKER_PLANS_URL
            },
            {
                text: formatText('broker-myInvestmentsPensionPlanExtraordinaryContribution')
            }
        ];
        const secId = immPensionPlan.get('pensionPlan').get('secId');
        const headerTitle = formatText('pensionPlanContribution-title');
        const hasPensionPlan = !!(immPensionPlanContribution.get('pensionPlan') && immPensionPlan.get('pensionPlan').size && secId);
        let bodyContent;
        let content = <LoadingSection />;

        if (hasPensionPlan) {
            content = <BrokerPensionPlanHeader immPensionPlan={immPensionPlan} immBrokerProductAdvancedSearch={immBrokerProductAdvancedSearch}/>;
        }
        if (__CONTACT_CENTER__ && !this.state.displayWizard && secId && !immHirePensionPlan.get('submitSuccessful')) {
            bodyContent = this.buildNextButtonWrappedLegalConfirmation();
        } else if (hasPensionPlan) {
            bodyContent = this.buildWizard();

        }

        if (immPensionPlanContribution.get('submitSuccessful')) {
            bodyContent = this.buildSuccessful();
        }
        else if(immPensionPlanContribution.get('isFetching')) {
            bodyContent = <LoadingSection />;
        }
        const ffUsPersonPensionPlansContribution = flagBasedFeatures.get('wealth_pension_plans_contribution_us_person');
        const contentRender = (
            <section className="broker-pension-plan-contribution-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        finalTitle={headerTitle}
                        >
                        <OKButton
                            inverse={true}
                            modifier="ghost"
                            to={BROKER_PLANS_HELP_URL}
                        >
                            <FormattedText
                                format="firstUppercase"
                                value="pensionPlanContribution-headerSecondLink"
                            />
                        </OKButton>
                    </OKHeaderSubPage>
                </OKCover>
                <section className="broker-pension-plan-contribution-view__body">
                    {content}
                    <div className="broker-pension-plan-contribution-view__wizard">
                        {bodyContent}
                    </div>
                </section>
            </section>
        )
        return (
            <ModalUsPersonBlock
                children={contentRender}
                featureFlag={ffUsPersonPensionPlansContribution}
                titleKey={'us_person_popup-pension_plans_contribution_title'}
                description={'us_person_popup-pension_plans_contribution_message'}
                buttonClick={() => history.push(BROKER_PG_URL)}
            />
        );
    }
}

BrokerPensionPlanContributionView.propTypes = {
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immPensionPlanContribution: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immPensionPlan: PropTypes.object.isRequired,
    getPensionPlans: PropTypes.func.isRequired,
    setContract: PropTypes.func.isRequired,
    setOriginalAmount: PropTypes.func.isRequired,
    onToggleDisclaimer: PropTypes.func.isRequired,
    setPeriodicity: PropTypes.func.isRequired,
    immHirePensionPlan: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired,
    clearSearchResults: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
    getInitPlansDocumentation: PropTypes.func,
};

module.exports.constructor = BrokerPensionPlanContributionView;
module.exports.BrokerPensionPlanContributionView = connect(
    state => ({
        immPensionPlanContribution: state.brokerPensionPlanContribution,
        immBrokerProductAdvancedSearch: state.brokerProductAdvancedSearch,
        immBrokerWallets: state.brokerWallets,
        immStocksContracts: state.brokerStocksContract,
        immPensionPlan: state.brokerPensionPlans,
        immAccounts: state.accounts,
        immHirePensionPlan: state.brokerHirePensionPlan,
        immPreContractualMail: state.preContractualMail,
        immProfileFields: state.profile,
        flagBasedFeatures: state.flagBasedFeatures,
        immSignaturePattern: state.signaturePattern,
    }), {
        validateStep: brokerPensionPlanContributionActions.validateStep,
        setPeriodicity: brokerPensionPlanContributionActions.setPeriodicity,
        setVisibleStep: brokerPensionPlanContributionActions.setVisibleStep,
        setWillCancel: brokerPensionPlanContributionActions.setWillCancel,
        handleFinish: brokerPensionPlanContributionActions.finish,
        reset: brokerPensionPlanContributionActions.reset,
        getPensionPlans: brokerPensionPlansActions.requestPensionPlan,
        setContract: brokerPensionPlanContributionActions.setContract,
        setOriginalAmount: brokerPensionPlanContributionActions.setOriginalAmount,
        onToggleDisclaimer: brokerPensionPlanContributionActions.toggleDisclaimer,
        requestProfile: profileActions.requestProfile,
        sendPreContractualMail: preContractualMailInfoActions.sendPreContractualMail,
        resetPrecontractualMail: preContractualMailInfoActions.resetPrecontractualMail,
        setDocumentsRead: brokerPensionPlanContributionActions.setDocumentsRead,
        clearSearchResults: brokerProductAdvancedSearchActions.clearResults,
        getInitPlansDocumentation,
    }
)(withRouter(BrokerPensionPlanContributionView));